import { render, staticRenderFns } from "./CollectionSubNav.vue?vue&type=template&id=4543a406&scoped=true"
import script from "./CollectionSubNav.vue?vue&type=script&lang=js"
export * from "./CollectionSubNav.vue?vue&type=script&lang=js"
import style0 from "./CollectionSubNav.vue?vue&type=style&index=0&id=4543a406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4543a406",
  null
  
)

export default component.exports